import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";
import type { RFQAttribute } from "./RFQ";

export default {
    updateRFQAttributes: (rfqPublicId: string, data: { [key: string]: any }): Promise<any> =>
        fetch(`${PURCHASER_API_BASE_URL}/v2/rfqs/${rfqPublicId}/attributes`, {
            method: "PUT",
            headers: getHeaders(),
            body: JSON.stringify(data),
        }).then(res => res.json()),

    getRFQAttributes: (): Promise<{ attributes: RFQAttribute[] }> =>
        fetch(`${PURCHASER_API_BASE_URL}/v2/rfqs/attributes`, {
            headers: getHeaders(),
            method: "GET",
        }).then(res => res.json()),
    addRFQAttribute: (rfqAttribute: { type: "STRING"; name: string; description: string | null; weight: number }): any =>
        fetch(`${PURCHASER_API_BASE_URL}/v2/rfqs/attributes`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify(rfqAttribute),
        }),
    updateRFQAttribute: (rfqAttribute: { id: number; type: "STRING"; name: string; description: string | null; weight: number }): any =>
        fetch(`${PURCHASER_API_BASE_URL}/v2/rfqs/attributes/${rfqAttribute.id}`, {
            method: "PUT",
            headers: getHeaders(),
            body: JSON.stringify(rfqAttribute),
        }),
    deleteRFQAttribute: (rfqAttributeId: number): Promise<any> =>
        fetch(`${PURCHASER_API_BASE_URL}/v2/rfqs/attributes/${rfqAttributeId}`, {
            method: "DELETE",
            headers: getHeaders(),
            body: JSON.stringify({}),
        }),
};
